import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import ScrollToTop from '../ScrollToTop';
import ScrollUpButton from '../ScrollUpButton';

export default function Layouts() {
  return (
    <div className="flex flex-col min-h-screen bg-[var(--color-background)]">
      <Header />
      <main className="flex-1 w-full max-w-8xl mx-auto">
        <ScrollToTop />
        <ScrollUpButton />
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
